import { Components, Theme } from "@mui/material/styles"

const Button = (theme: Theme): Components => {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          transition: "all 0.3s ease",
          textTransform: "initial",
          borderRadius: "6px",
          ":hover": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: "0.3rem",
        },
      },
    },
    MuiTouchRipple: {
      styleOverrides: {
        root: {
          color: theme.palette.secondary.main,
        },
      },
    },
  }
}

export default Button
